<template>
    <button class="sq-btn" :class="[ 'sq-btn__' + type, 'sq-btn--' + size, 'sq-btn__' + type + '--' + animation ]" :disabled="disabled" type="button"><slot></slot></button>  
</template>

<script>
export default {
  name: 'custom-button',
  props: {
    type: {
        type: String,
        default: 'default'
    },
    disabled: Boolean,
    size: {
        type: String,
        default: 'lg'
    },
    animation: {
      type: String,
      default: 'none'
    }
  }
}
</script>